// Ported from eb-ui `src/legacy/Collection/CollectionError.tsx` — the
// "collection moved / doesn't exist" render (the page's second render path).
//   - `@eventbrite/eds-layout` → `../lib/eds/Layout`.
//   - `@eventbrite/legacy-infra.i18n` → `@/lib/gettext`.
//   - types → `@/types` (via the local `_shared` copies' transitive types).
import React from 'react';

import { CardsCarousel, CardsType } from '../CardsCarousel/CardsCarousel';
import { AffiliateCodes, OtherEventsYouMayLike } from '@/types';
import { getOtherEventsYouMayLikeTitle } from '../_shared/constants';
import { Layout } from '../lib/eds/Layout';
import { gettext } from '@/lib/gettext';
import { CollectionErrorSvg } from './CollectionErrorSvg';

interface Props {
    otherEventsYouMayLikeProps?: OtherEventsYouMayLike;
}

export const CollectionError: React.FC<Props> = ({
    otherEventsYouMayLikeProps,
}) => {
    const otherEventsYouMayLike = otherEventsYouMayLikeProps?.events;

    return (
        <>
            <Layout maxWidth="large" hasHorizontalGutters={true}>
                <div className="eds-text--center eds-l-mar-vert-20">
                    <i
                        className="eds-vector-image eds-vector-image-size--reset"
                        aria-hidden="true"
                    >
                        <CollectionErrorSvg />
                    </i>
                    <h1 className="eds-text-hs eds-l-mar-top-10">
                        {gettext(
                            'This collection either doesn’t exist or has changed.',
                        )}
                    </h1>
                </div>
            </Layout>
            {otherEventsYouMayLike?.length ? (
                <Layout maxWidth="large" hasHorizontalGutters={true}>
                    <div className="cc-outer-wrapper">
                        <CardsCarousel
                            cards={otherEventsYouMayLike}
                            cardsType={CardsType.EVENT}
                            title={getOtherEventsYouMayLikeTitle()}
                            newTitleStyle={true}
                            affCode={
                                AffiliateCodes.RelatedEventsOtherOrganizers
                            }
                            isFromDestination={true}
                            dataTestId="oeyml-carousel"
                        />
                    </div>
                </Layout>
            ) : null}
        </>
    );
};
